
























import {
  Component,
  Prop,
  Mixins,
  Watch,
} from 'vue-property-decorator';
import NormalizerMixin from '@/mixins/NormalizerMixin';

@Component
export default class CustomSelect extends Mixins(NormalizerMixin) {
  @Prop()
  value!: any;

  @Prop()
  label!: string;

  @Prop()
  items!: Array<any>;

  @Prop()
  dense!: boolean;

  @Prop()
  disabled!: boolean;

  @Prop({
    type: Boolean,
    default: false,
  }) readonly outlined!: boolean

  @Prop({
    type: String,
    default: '',
  }) readonly prependIcon!: string

  // Прокидываем hide-details в v-select. Default false — поведение существующих использований
  // не меняется (резерв под v-messages). 'auto' убирает пустую область, но оставляет ошибки.
  @Prop({
    type: [Boolean, String],
    default: false,
  }) readonly hideDetails!: boolean | string

  @Prop({
    default: false,
  })
  alwaysEmit!: boolean;

  @Prop({
    default: null,
  })
  loading!: boolean | null;

  @Prop()
  errorMessages!: Array<string> | string;

  // id'шники айтемов, которые рендерим жирным (напр. центры затрат с постфиксом
  // выбранной платформы). Default [] — для всех прочих использований no-op.
  @Prop({
    default: () => [],
  })
  readonly boldItemIds!: Array<string | number>;

  internalValue: any = null;

  isBoldItem(item: any): boolean {
    if (!this.boldItemIds.length || item?.id == null) return false;
    return this.boldItemIds.map(String).includes(String(item.id));
  }

  get isLoading() {
    if (this.loading === null) {
      return !this.items.length;
    }
    return this.loading;
  }

  beforeMount() {
    this.selectCurrentValueFromItems();
  }

  selectCurrentValueFromItems() {
    if (this.value && this.items?.length) {
      for (let i = 0; i < this.items.length; i += 1) {
        const item = this.items[i];
        if (parseInt(item.id, 10) === parseInt(this.value.id, 10)) {
          this.internalValue = item;
          if (this.alwaysEmit) {
            this.onChange(item);
          }
        }
      }
    } else {
      this.internalValue = null;
    }
  }

  @Watch('items')
  itemsChanged() {
    this.selectCurrentValueFromItems();
  }

  @Watch('value')
  valueChanged() {
    this.selectCurrentValueFromItems();
  }

  onChange(item: any) {
    this.$emit('change', item);
    this.$emit('input', item);
  }
}
